\:host
    width: 100%

.CheckoutContainer
    margin-left: 15px
    margin-right: 5px
    display: flex
    flex-direction: row
    flex: 1
    align-items: center
    justify-content: space-between
    z-index: $indexCartButton
    cursor: pointer
    stroke: rgb($globalSettingsFontSecondary)
    color: rgb($globalSettingsFontSecondary)
    &:hover
        stroke: rgb($globalSettingsFontPrimary)
        color: rgb($globalSettingsFontPrimary)

.ShowArticleContainer
    display: flex
    flex-direction: row
    align-items: center
    cursor: pointer

.Summary
    border-radius: $globalButtonRounding
    padding: 5px 10px
    display: flex
    flex-direction: column
    align-items: flex-end
    box-sizing: border-box
    .Price
        font-size: 12px
        text-align: right
    .SubtlePrice
        color: gray
.Animated
    animation-name: totalAnimation1
    animation-duration: 1s
@keyframes totalAnimation1
    0%
        transform: scale(1)
    25%
        transform: scale(1.1)
    50%
        transform: scale(1)
    75%
        transform: scale(1.1)
    100%
        transform: scale(1)
